/** Íslenska. */
export default {
  header: {
    features: 'Eiginleikar',
    pricing: 'Verð',
    contact: 'Hafa samband',
    getStarted: 'Byrjaðu',
    login: 'Innskráning',
  },

  footer: {
    description:
      'Vettvangur fyrir félagsmenn, útleigu sala, viðburði og bókhald, gerður fyrir félög.',
    product: 'Vara',
    help: 'Aðstoð',
    legal: 'Lögfræði',
    features: 'Eiginleikar',
    pricing: 'Verð',
    getStarted: 'Byrjaðu',
    contactUs: 'Hafðu samband',
    privacy: 'Persónuvernd',
    terms: 'Skilmálar',
    copyright: 'Öll réttindi áskilin.',
  },

  home: {
    unknownTenant:
      'Ekkert virkt félag fannst á {host}. Ef félagið var nýstofnað getur tekið nokkrar mínútur þar til síðan er tilbúin - reyndu að endurhlaða síðuna eftir smástund. Ef þú ert í vafa um veffangið, eða vandamálið heldur áfram, vinsamlegast',
    unknownTenantHere: 'þessu veffangi',
    unknownTenantContact: 'hafðu samband',
    heroTitlePre: 'Gerðu félagið þitt stafrænt með',
    heroSubtitle:
      'Vettvangur fyrir félagsmenn, útleigu sala, viðburði og bókhald, gerður fyrir félög.',
    ctaFree: 'Byrjaðu ókeypis',
    learnMore: 'Nánar',
    featuresTitle: 'Það sem þú þarft til að reka félagið',
    featuresSubtitle: 'Verkfærin saman á einum vettvangi',
    features: [
      { icon: '👥', title: 'Félagaskrá', desc: 'Félagar, aðild og heimili, með reikningi þegar aðild er endurnýjuð.' },
      { icon: '🏠', title: 'Útleiga sala', desc: 'Bókanir með verði, samningi, tryggingagjaldi og reikningi.' },
      { icon: '📅', title: 'Viðburðir', desc: 'Miðasala með hámarksfjölda og QR-kóði við dyrnar.' },
      { icon: '💳', title: 'Reikningar og greiðslur', desc: 'Reikningar og kreditreikningar, og greiðsla með korti og Vipps í gegnum Nets.' },
      { icon: '📧', title: 'Tölvupóstur og SMS', desc: 'Staðfestingar, áminningar, reikningar og miðar eru sendir sjálfkrafa.' },
      { icon: '🌐', title: 'Eigin vefsíða', desc: 'Eigin síða félagsins með síðum, fréttum og eigin útliti.' },
    ],
    stepsTitle: 'Svona byrjar þú',
    steps: [
      { num: 1, title: 'Sendu beiðni', desc: 'Segðu okkur frá félaginu og við setjum upp síðuna ykkar.' },
      { num: 2, title: 'Settu upp', desc: 'Skráðu sali, tegundir aðildar og verð.' },
      { num: 3, title: 'Taktu í notkun', desc: 'Taktu við bókunum, seldu miða og sendu reikninga.' },
    ],
    ctaTitle: 'Tilbúið að einfalda félagsstarfið?',
    ctaText: 'Byrjaðu ókeypis í dag. Enginn binditími.',
    ctaButton: 'Byrjaðu ókeypis',
    heroImageAlt: 'Yfirlitið í stjórnkerfi sýnifélags',
  },

  features: {
    heroTitle: 'Öflugir eiginleikar fyrir félagið þitt',
    heroSubtitle: 'Félagar, útleiga, viðburðir, reikningagerð og bókhald á einum vettvangi.',
    list: [
      {
        icon: '👥',
        title: 'Félagastjórnun',
        description: 'Félagar, aðild og heimili á einum stað.',
        details: [
          'Tegundir aðildar og heimili með börnum',
          'Endurnýjun með reikningi',
          'Sjálfboðavinna og tímar',
        ],
      },
      {
        icon: '🏠',
        title: 'Útleiga sala',
        description: 'Taktu við og fylgdu eftir bókunum.',
        details: [
          'Verð, viðbætur og frídagar',
          'Samningur sem er undirritaður á netinu',
          'Tryggingagjald og reikningur',
        ],
      },
      {
        icon: '📅',
        title: 'Viðburðir',
        description: 'Seldu miða og hleyptu réttu fólki inn.',
        details: [
          'Miðasala með hámarksfjölda',
          'Miðategundir í röð, til dæmis snemmbúin sala og sala við dyrnar',
          'QR-kóði við dyrnar',
        ],
      },
      {
        icon: '💳',
        title: 'Reikningar og greiðslur',
        description: 'Reikningar og kreditreikningar, og kortagreiðsla.',
        details: [
          'Reikningar með innheimtuáminningu',
          'Kort og Vipps í gegnum Nets',
          'Bókhald og reikningsskipulag',
        ],
      },
      {
        icon: '📧',
        title: 'Samskipti',
        description: 'Skilaboð eru send sjálfkrafa á réttum tíma.',
        details: ['Tölvupóstur og SMS', 'Sniðmát á mörgum tungumálum', 'Tilkynningar á réttum tíma'],
      },
      {
        icon: '🌐',
        title: 'Eigin vefsíða',
        description: 'Eigin síða félagsins með síðum og fréttum.',
        details: ['Síður og fréttir', 'Þrjú útlit og eigin litir', 'Eigið lén (við setjum það upp)'],
      },
      {
        icon: '🔐',
        title: 'Öryggi og persónuvernd',
        description: 'Hvert félag er aðskilið frá hinum.',
        details: [
          'Tveggja þátta innskráning',
          'Gögn eru vistuð í Noregi',
          'Aðgangur, útflutningur og eyðing persónuupplýsinga',
        ],
      },
    ],
    ctaTitle: 'Tilbúið að byrja?',
    ctaText: 'Byrjaðu ókeypis í dag og upplifðu hve einfalt getur verið að reka félag.',
    ctaButton: 'Byrjaðu ókeypis',
    screensTitle: 'Svona lítur það út',
    screensSubtitle: 'Skjámyndir frá sýnifélagi með uppspunnin gögn. Stjórnkerfið er á norsku.',
    screens: [
      { title: 'Yfirlit', text: 'Það sem þarf að fylgja eftir, og hvað er framundan, á einni síðu.' },
      { title: 'Bókanir', text: 'Beiðnir, staðfestingar og staða allra bókana.' },
      { title: 'Dagatal', text: 'Gestir sjá hvenær salirnir eru lausir og hvað er að gerast í húsinu.' },
      { title: 'Miðar', text: 'Sala eftir tegund miða, gestir og innritun.' },
      { title: 'Veldu sæti', text: 'Kaupandinn velur sér sæti á korti af salnum.' },
      { title: 'Salarkort', text: 'Dragðu borð, stóla, svið og bar inn á kortið, með grunnmynd í bakgrunni.' },
      { title: 'Aðild', text: 'Félagar, tegundir aðildar og heimili.' },
      { title: 'Reikningar', text: 'Reikningar og kreditreikningar með stöðu, gjalddaga og eftirstöðvum.' },
      { title: 'Í símanum', text: 'Vefsíða félagsins virkar í síma.' },
    ],
  },

  pricing: {
    heroTitle: 'Einföld og gagnsæ verðlagning',
    heroSubtitle: 'Veldu áskriftina sem hentar félaginu þínu.',
    loading: 'Sæki verð...',
    loadError: 'Ekki tókst að sækja uppfærð verð. Sýni vistuð verð.',
    popular: 'Vinsælast',
    perMonth: 'kr/mán.',
    unlimited: 'Ótakmarkað',
    unlimitedMembers: 'Ótakmarkaður fjöldi félaga',
    upToMembers: 'Allt að {count} félagar',
    prioritySupport: 'Forgangsþjónusta: við byrjum innan 30 mínútna, virka daga 9–15',
    planDescFree: 'Fyrir lítil félög',
    planDescStandard: 'Fyrir virk félög',
    planDescAdvanced: 'Fyrir stór samtök',
    ctaFree: 'Byrjaðu ókeypis',
    ctaTrial: 'Sendu beiðni',
    faqTitle: 'Algengar spurningar',
    faq: [
      { q: 'Get ég skipt um áskriftarleið hvenær sem er?', a: 'Já, hafðu samband og við skiptum um áskrift.' },
      { q: 'Hvað gerist ef við förum yfir félagatakmarkið?', a: 'Við höfum samband og komum okkur saman um uppfærslu. Engu er lokað án þess að við höfum rætt við ykkur.' },
      { q: 'Er binditími?', a: 'Nei, öllum áskriftarleiðum má segja upp hvenær sem er.' },
      { q: 'Bjóðið þið afslátt fyrir góðgerðarfélög?', a: 'Já, hafðu samband til að fá sérkjör fyrir góðgerðar- og sjálfboðaliðafélög.' },
      { q: 'Hvað kostar kortagreiðsla?', a: 'Kort og Vipps fara í gegnum Nets. Félagið er með eigin samning við Nets og greiðir gjaldið beint til þeirra.' },
    ],
    emailSms: 'Tölvupóstur og SMS',
    bookingsPerMonth: '{count} bókanir á mánuði',
    unlimitedBookings: 'Ótakmarkaðar bókanir',
    ticketsPerMonth: '{count} miðar á mánuði',
    unlimitedTickets: 'Ótakmarkaðir miðar',
    locations: 'Allt að {count} salir',
    unlimitedLocations: 'Ótakmarkaðir salir',
    storage: '{size} geymslupláss',
    customBranding: 'Eigið útlit og eigin litir',
    exportCsv: 'Útflutningur í CSV',
    introNotice:
      'Á upphafstímabili eru allar áskriftir ókeypis. Við látum vita með minnst 30 daga fyrirvara áður en reikningagerð hefst.',
  },

  contact: {
    heroTitle: 'Hafðu samband',
    heroSubtitle:
      'Við erum hér til að hjálpa. Skrifaðu okkur og við svörum eins fljótt og við getum.',
    formTitle: 'Skrifaðu okkur',
    formIntro:
      'Hefurðu spurningar um CommunityNord, verð eða hvernig við getum hjálpað félaginu þínu? Fylltu út eyðublaðið eða sendu okkur tölvupóst.',
    email: 'Netfang',
    name: 'Nafn',
    organization: 'Félag/Samtök',
    subject: 'Efni',
    chooseSubject: 'Veldu efni',
    subjectGeneral: 'Almenn fyrirspurn',
    subjectPricing: 'Verð og áskrift',
    subjectSupport: 'Tækniaðstoð',
    subjectDemo: 'Óska eftir kynningu',
    subjectPartnership: 'Samstarf',
    message: 'Skilaboð',
    send: 'Senda skilaboð',
    success:
      'Takk! Við höfum tekið á móti skilaboðunum þínum og höfum samband eins fljótt og við getum.',
    error: 'Eitthvað fór úrskeiðis. Reyndu aftur eða sendu okkur tölvupóst.',
    tooMany: 'Þú hefur sent mörg skilaboð. Reyndu aftur síðar eða sendu okkur tölvupóst.',
    sending: 'Sendi...',
    supportNote:
      'Staðlað og Ítarlegt hafa forgangsþjónustu: við byrjum á málinu innan 30 mínútna, virka daga 9–15.',
  },

  login: {
    title: 'Skrá inn',
    subtitle:
      'Hvert félag hefur sína eigin innskráningu. Skrifaðu heimilisfang félagsins og við förum með þig þangað.',
    label: 'Heimilisfang félagsins',
    placeholder: 'felagid',
    button: 'Fara í innskráningu',
    hint:
      'Ef félagið er með eigið lén notarðu það í staðinn. Finnirðu ekki heimilisfangið skaltu spyrja stjórnina eða hafa samband við okkur.',
    invalid: 'Notaðu aðeins lágstafi, tölustafi og bandstrik.',
  },

  signup: {
    heroTitle: 'Byrjaðu með CommunityNord',
    heroSubtitle:
      'Fylltu út eyðublaðið til að stofna nýtt félag. Við sendum þér tölvupóst þegar aðgangurinn þinn er tilbúinn.',
    formTitle: 'Stofna nýtt félag',
    success:
      'Takk fyrir fyrirspurnina! Við höfum móttekið beiðnina og höfum samband um leið og aðgangurinn þinn er tilbúinn.',
    error: 'Villa kom upp við sendingu. Vinsamlegast reyndu aftur eða hafðu samband.',
    orgName: 'Nafn félags',
    orgNamePlaceholder: 'Nafn félagsins',
    contactPerson: 'Tengiliður',
    contactPersonPlaceholder: 'Fullt nafn þitt',
    email: 'Netfang',
    phone: 'Sími',
    plan: 'Óskuð áskriftarleið',
    messageOptional: 'Skilaboð (valfrjálst)',
    messagePlaceholder: 'Segðu okkur aðeins frá félaginu þínu...',
    sending: 'Sendi...',
    submit: 'Senda beiðni',
    free: 'Ókeypis',
    perMonth: 'kr/mán.',
    upTo50: 'Allt að 50 félagar',
    upTo500: 'Allt að 500 félagar',
    unlimitedMembers: 'Ótakmarkaður fjöldi félaga',
    nextTitle: 'Hvað gerist næst?',
    nextSteps: [
      { title: 'Umsókn send', desc: 'Við móttökum umsóknina og sendum staðfestingu á netfangið þitt.' },
      { title: 'Afgreiðsla', desc: 'Teymið okkar afgreiðir umsóknina, yfirleitt innan 1-2 virkra daga.' },
      { title: 'Velkomin(n)', desc: 'Þú færð boðshlekk í tölvupósti til að stofna aðganginn þinn.' },
    ],
    questionsTitle: 'Spurningar?',
    questionsContact: 'Hafðu samband á',
  },

  onboarding: {
    homeTitle: 'CommunityNord innleiðing',
    homeSubtitle:
      'Til að stofna nýtt félag þarftu boðshlekk. Hafðu samband við stjórnanda til að fá hann sendan.',
    homeGotLink: 'Hefurðu fengið hlekk?',
    homeGotLinkText:
      'Smelltu á hlekkinn sem þú fékkst í tölvupósti til að hefja uppsetningu félagsins.',
    homeBack: '← Til baka á communitynord.com',
    validating: 'Staðfesti boðið...',
    invalidTitle: 'Ógilt boð',
    invalidContact: 'Hafðu samband við stjórnandann til að fá nýjan boðshlekk.',
    connectError: 'Náði ekki sambandi við þjóninn. Reyndu aftur síðar.',
    deviceBound:
      'Þessi tengill hefur þegar verið opnaður í öðru tæki og er bundinn því. Opnaðu tengilinn í fyrra tækinu til að halda áfram, eða skrifaðu á support@communitynord.com og við sendum nýjan tengil.',
    genericError: 'Eitthvað fór úrskeiðis. Reyndu aftur.',
    steps: ['Velkomin', 'Félag', 'Tengiliður', 'Aðgangur', 'Staðfesta'],
    step1Title: 'Velkomin í CommunityNord',
    step1Subtitle:
      'Þér hefur verið boðið að stofna nýtt félag. Við leiðum þig í gegnum uppsetninguna skref fyrir skref.',
    step1Suggested: 'Tillaga að nafni:',
    step1SentTo: 'Boð sent á:',
    step1Expires: 'Boðið rennur út:',
    step1Needs: 'Þetta þarftu:',
    step1NeedsList: [
      'Nafn félagsins',
      'Tengiliðaupplýsingar',
      'Kennitölu/skráningarnúmer, ef við á',
      'Óskað notandanafn og lykilorð',
    ],
    step1Start: 'Byrjaðu →',
    back: '← Til baka',
    next: 'Áfram →',
    step2Title: 'Um félagið',
    step2Subtitle: 'Segðu okkur frá félaginu sem mun nota kerfið.',
    orgName: 'Nafn félags',
    orgNamePlaceholder: 'T.d. Ungmennahús Reykjavíkur',
    orgNameRequired: 'Nafn félags er nauðsynlegt',
    slug: 'URL-forskeyti (slug)',
    slugRequired: 'URL-forskeyti er nauðsynlegt',
    slugFormat: 'Aðeins lágstafir, tölur og bandstrik',
    slugMin: 'Að minnsta kosti 2 stafir',
    shortName: 'Stuttnefni',
    shortNameRequired: 'Stuttnefni er nauðsynlegt',
    shortNameMax: 'Hámark 10 stafir',
    shortNameFormat: 'Aðeins bókstafir og tölur',
    shortNameHint: 'Notað sem forskeyti í reikningsnúmerum o.fl.',
    customDomain: 'Eigið lén',
    customDomainPlaceholder: 't.d. daemi.is',
    customDomainHint: 'Valfrjálst. Veitir aðgang um eigið lén til viðbótar við undirlénið.',
    customDomainNoProtocol: 'Skrifaðu aðeins lénið, án http:// eða https://',
    customDomainNoPath: 'Skrifaðu aðeins lénið, án slóðar',
    customDomainInvalid: 'Ógilt lénssnið',
    country: 'Land',
    countryHint: 'Landið sem félagið tilheyrir',
    countryNames: { NO: 'Noregur', SE: 'Svíþjóð', DK: 'Danmörk' },
    orgNumber: 'Skráningarnúmer',
    orgNumberHint: 'Valfrjálst. Kennitala eða skráningarnúmer félags.',
    appearance: 'Útlit',
    layout: 'Útlit vefsíðunnar',
    layoutHint: 'Hægt að breyta hvenær sem er undir Stjórnun → Vörumerki.',
    layouts: [
      { key: 'classic', name: 'Klassískt', description: 'Hefðbundin uppsetning með miðjuðu efni og merki til vinstri. Hentar flestum.' },
      { key: 'modern', name: 'Nútímalegt', description: 'Forsíða í fullri breidd og fyrirferðarlítill haus. Ferskur og léttur stíll.' },
      { key: 'compact', name: 'Þjappað', description: 'Lágmarksloft og þéttar upplýsingar. Gott fyrir efnismiklar síður.' },
      { key: 'custom', name: 'Sérsniðið', description: 'Eigin hönnun unnin í samstarfi við okkur. Við höfum samband.' },
    ],
    tagline: 'Slagorð / einkunnarorð',
    taglinePlaceholder: 'T.d. „Saman sköpum við starfsemi“',
    taglineHint: 'Valfrjálst. Birtist í síðufæti vefsíðunnar.',
    logo: 'Merki',
    logoUpload: 'Hlaða upp merki',
    logoChange: 'Skipta um mynd',
    logoRemove: 'Fjarlægja',
    logoHint: 'Valfrjálst. PNG/JPG/SVG, hámark 2 MB. Má einnig bæta við síðar.',
    logoTooBig: 'Myndin er of stór (hámark 2 MB)',
    logoNotImage: 'Skráin verður að vera mynd',
    logoUseUrl: 'Nota vefslóð í staðinn',
    logoUrlPlaceholder: 'https://...',
    logoUrlHint: 'Alger vefslóð á merkið (https://...).',
    subscriptionPlan: 'Áskriftarleið',
    subscriptionPlanHint: 'Þessi leið verður upphafsáskrift og má breyta í gáttinni síðar.',
    step3Title: 'Tengiliðaupplýsingar',
    step3Subtitle: 'Hver er aðaltengiliður félagsins? Þessi aðili verður eigandi aðgangsins.',
    contactPerson: 'Tengiliður',
    contactPersonRequired: 'Tengiliður er nauðsynlegur',
    email: 'Netfang',
    emailRequired: 'Netfang er nauðsynlegt',
    emailInvalid: 'Ógilt netfang',
    phone: 'Símanúmer',
    postalAddress: 'Póstfang',
    optional: '(valfrjálst)',
    streetAddress: 'Heimilisfang',
    city: 'Staður',
    postalCode: 'Póstnr.',
    sameAsPostal: 'Heimsóknarfang er það sama og póstfang',
    visitingAddress: 'Heimsóknarfang',
    step4Title: 'Stofna notandaaðgang',
    step4Subtitle:
      'Þessi notandi verður eigandi félagsins með fullan aðgang. Þú getur bætt við fleiri notendum síðar.',
    username: 'Notandanafn',
    usernameRequired: 'Notandanafn er nauðsynlegt',
    usernameMin: 'Að minnsta kosti 3 stafir',
    usernameMax: 'Hámark 256 stafir',
    usernameEmailInvalid: 'Ógilt netfangssnið',
    usernameFormat:
      'Notaðu notandanafnasnið (a-z, 0-9, punktur, undirstrik, bandstrik) eða gilt netfang',
    usernamePlaceholder: 'jon.jonsson eða nafn@len.is',
    usernameHint: 'Notað við innskráningu. Getur verið notandanafn eða netfang.',
    loginEmail: 'Netfang (fyrir innskráningu)',
    loginEmailHint: 'Sótt úr tengiliðaupplýsingum í fyrra skrefi.',
    password: 'Lykilorð',
    passwordRequired: 'Lykilorð er nauðsynlegt',
    passwordMin: 'Að minnsta kosti 8 stafir',
    passwordShow: 'Sýna',
    passwordHide: 'Fela',
    passwordHint: 'Ábending: Notaðu blöndu af há-/lágstöfum, tölum og sértáknum.',
    passwordConfirm: 'Staðfesta lykilorð',
    passwordConfirmPlaceholder: 'Endurtaktu lykilorðið',
    passwordMismatch: 'Lykilorðin stemma ekki',
    step5Title: 'Staðfesta og stofna',
    step5Subtitle:
      'Farðu yfir upplýsingarnar áður en þú stofnar félagið. Þú getur farið til baka til að gera breytingar.',
    reviewOrg: 'Félag',
    reviewName: 'Nafn',
    reviewUrl: 'URL',
    reviewCustomDomain: 'Eigið lén',
    reviewCountry: 'Land',
    reviewShortName: 'Stuttnefni',
    reviewOrgNumber: 'Skr.nr.',
    reviewPlan: 'Áskrift',
    reviewLayout: 'Útlit',
    reviewTagline: 'Slagorð',
    reviewLogo: 'Merki',
    reviewContact: 'Tengiliður',
    reviewContactPerson: 'Tengiliður',
    reviewEmail: 'Netfang',
    reviewPhone: 'Sími',
    reviewPostal: 'Póstfang',
    reviewVisiting: 'Heimsóknarfang',
    reviewAddress: 'Heimilisfang',
    reviewPlace: 'Staður',
    reviewAccount: 'Notandaaðgangur',
    reviewUsername: 'Notandanafn',
    reviewPassword: 'Lykilorð',
    reviewRole: 'Hlutverk',
    reviewOwner: 'Eigandi (Owner)',
    creating: 'Stofna...',
    create: 'Stofna félag ✓',
    successTitle: '{name} hefur verið stofnað!',
    successAwaiting:
      'Við undirbúum nú vefsíðuna ykkar — þetta er handvirkt skref þar sem við göngum úr skugga um að allt sé rétt uppsett. Þið fáið tölvupóst á {email} um leið og síðan er tilbúin til notkunar.',
    successAwaitingNoEmail:
      'Við undirbúum nú vefsíðuna ykkar — þetta er handvirkt skref þar sem við göngum úr skugga um að allt sé rétt uppsett. Þið fáið tölvupóst um leið og síðan er tilbúin til notkunar.',
    successWhatNow: 'Hvað gerist núna?',
    successStep1:
      'Við yfirförum uppsetninguna og gerum síðuna tilbúna. Það tekur yfirleitt stuttan tíma.',
    successStep2: 'Þið fáið tölvupóst þegar síðan er tilbúin, með innskráningarhlekk.',
    successStep3: 'Skráðu þig inn með notandanafninu {username} og lykilorðinu sem þið völduð.',
    successDetails: 'Þínar upplýsingar',
    successOrg: 'Félag',
    successUrl: 'Veffang',
    successUsername: 'Notandanafn',
    successDnsTitle: 'Eigið lén: {domain}',
    successDnsIntro:
      'Til að {domain} vísi á vefsíðuna ykkar þarf að uppfæra DNS-stillingar hjá lénveitunni ykkar. Veldu annan möguleikann:',
    successDnsCnameTitle: 'Möguleiki 1 — CNAME (einfaldast)',
    successDnsCnameText: 'Stofnaðu CNAME-færslu sem vísar á undirlénið ykkar:',
    successDnsATitle: 'Möguleiki 2 — A-færsla',
    successDnsAText: 'Beindu léninu beint á IP-tölu þjónsins okkar:',
    successDnsNote:
      'DNS-breytingar geta tekið allt að nokkrar klukkustundir að taka gildi. Athugið: CNAME er ekki hægt að nota á rótarlén (daemi.is) hjá öllum veitum — notaðu þá A-færslu, eða CNAME á www. Við staðfestum lénið sem hluta af undirbúningnum.',
    successDnsType: 'Tegund',
    successDnsName: 'Nafn/hýsill',
    successDnsValue: 'Gildi/áfangastaður',
  },
}
